// sessionStorage persiste tant que l'onglet est ouvert (idéal ici)
const BASE = 'tripFormDraft';

function key(productId) {
  return `${BASE}:${productId || 'unknown'}`;
}

export function readFormDraft(productId) {
  try {
    const raw = sessionStorage.getItem(key(productId));

    
return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function writeFormDraft(productId, draft) {
  try {
    sessionStorage.setItem(key(productId), JSON.stringify(draft));
  } catch {}
}

export function clearFormDraft(productId) {
  try { sessionStorage.removeItem(key(productId)); } catch {}
}